import type { Group, QuestionImage } from '@api/instant_survey/types';

import styles from './_index.module.scss';

type ConceptPreviewItem = {
  conceptImage: QuestionImage;
  conceptName?: null | string;
};

interface ConceptPreviewProps {
  groups?: Group[];
}

const getConceptPreviews = (groups: Group[] = []): ConceptPreviewItem[] =>
  groups.flatMap(({ conceptImage, conceptName }) => {
    if (!conceptImage || (!conceptImage.cdnUrl && !conceptImage.previewUrl)) return [];

    return [{ conceptImage, conceptName }];
  });

const ConceptPreview = ({ groups = [] }: ConceptPreviewProps) => {
  const conceptPreviews = getConceptPreviews(groups);

  if (conceptPreviews.length === 0) return null;

  return (
    <div className={styles['concept-preview']} data-testid="concept-previews">
      {conceptPreviews.map(({ conceptImage, conceptName }, index) => (
        <img
          alt={conceptName || `Concept image ${index + 1}`}
          key={conceptImage.id ?? `${conceptImage.cdnUrl || conceptImage.previewUrl}-${index}`}
          src={conceptImage.cdnUrl || conceptImage.previewUrl}
        />
      ))}
    </div>
  );
};

export default ConceptPreview;
